//@flow

//import type { APIresponse, rawObjectFromAPI } from "../flowTypes.js";

const ADD_OBJECT = "ADD_OBJECT"
const ADD_LIST = "ADD_LIST"
const ADD_PATH_ID = "ADD_PATH_ID"
//const ADD_LIST = "ADD_LIST";
const ADD_CHILDREN = "ADD_CHILDREN"
const UPDATE_PROP = "UPDATE_PROP"
const ADD_OBJECT_CHUNK = "ADD_OBJECT_CHUNK"
const REMOVE_OBJECT = "REMOVE_OBJECT"
const REMOVE_CHILDREN = "REMOVE_CHILDREN"
const DROP_DATA = "DROP_DATA"
//const DELETE_ALLOBJECT = "DELETE_ALLOBJECT";
//const REMOVE_OBJECT = "REMOVE_OBJECT";
//const REMOVE_PROPERTY = "REMOVE_PROPERTY";

export const addObject = (objectName, objectProps, objectId, ts) => {
  if (objectProps == null) {
    throw new Error("Object unavaiable on API response: " + objectName)
  }
  let action = {
    type: ADD_OBJECT,
    name: objectName,
    object: objectProps,
    id: String(objectId),
    ts,
  }

  return action
}

export const addList = (objectName, listResponse, pkName, ts) => {
  const objectChunk = {}
  for (const obj of listResponse) {
    objectChunk[obj[pkName]] = {
      props: { ...obj },
      ts,
    }
  }

  let action = {
    type: ADD_LIST,
    name: objectName,
    objectChunk: objectChunk,
  }

  return action
}

export const addPathId = (path, id) => {
  let action = {
    type: ADD_PATH_ID,
    path,
    id,
  }
  return action
}

export const addObjectChunk = objectChunk => {
  let action = {
    type: ADD_OBJECT_CHUNK,
    objectChunk,
  }

  return action
}

export const updateProp = (objectName, objectId, propName, propValue) => {
  let action = {
    type: UPDATE_PROP,
    name: objectName,
    id: objectId,
    propName: propName,
    value: propValue,
    ts: Math.floor(Date.now() / 1000),
  }

  return action
}

export const removeObject = (objectName, objectId) => {
  let action = {
    type: REMOVE_OBJECT,
    name: objectName,
    id: objectId,
  }

  return action
}

export const removeChildren = (objectName, objectId, childName) => {
  let action = {
    type: REMOVE_CHILDREN,
    name: objectName,
    id: objectId,
    childName: childName,
  }

  return action
}

export const addChildren = (parentName, parentID, oName, ids, ts) => {
  return {
    type: ADD_CHILDREN,
    parentName,
    parentID,
    oName,
    ids,
    ts,
  }
}

export const dropAllData = () => ({
  type: DROP_DATA,
})

/*
export type removeObjectAction = {|
  type: string,
  oName: string,
  id: string
|};
export const removeObject = (oName: string, id: string) => {
  let action: removeObjectAction = {
    type: REMOVE_OBJECT,
    oName,
    id
  };
  return action;
};

export type deleteAllObjectAction = {|
  type: string,
  oName: string
|};
export const deleteAllObject = (oName: string) => {
  let action: deleteAllObjectAction = {
    type: DELETE_ALLOBJECT,
    oName
  };
  return action;
};
*/
